import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Hint, Inscription, useResponsive } from '@common-fe/common-fe';

import useEmployerTerminationBanner from '@/modules/core/hooks/useEmployerTerminationBanner';
import AddDependentModal from '@/modules/user/components/ManageProfile/components/Dependents/components/DependentsModal/AddDependentModal';

const HINT_TEXT = 'Terminated Organization cannot add dependents';

const DependentsHeader = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [isAddDependentModalVisible, setIsAddDependentModal] = useState(false);
  const { isDisabledDueToTermination } = useEmployerTerminationBanner();
  const handleOpenAddDependentModal = useCallback(() => {
    setIsAddDependentModal(true);
  }, []);

  return (
    <>
      <Box direction="row" justify="between" align="center">
        {!isMobile && (
          <Inscription size="large" weight={700}>
            {t('Dependents')}
          </Inscription>
        )}
        <Hint
          hintAlign="left"
          hintWidth={220}
          hideHint={!isDisabledDueToTermination}
          hintElement={
            <AppButton
              fill={isMobile}
              buttonType="secondary"
              onClick={handleOpenAddDependentModal}
              disabled={isDisabledDueToTermination}
            >
              {t('Add Dependent')}
            </AppButton>
          }
          marginContent="m"
        >
          <Box direction="row" justify="center" align="center">
            <Inscription textAlign="center">{HINT_TEXT}</Inscription>
          </Box>
        </Hint>
      </Box>
      {isAddDependentModalVisible && <AddDependentModal onSetVisible={setIsAddDependentModal} />}
    </>
  );
};

export default DependentsHeader;
